export default __webpack_public_path__ + "static/media/bitcoin.acb3776d.svg";